import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CountdownDisplay from '@/pages/CountdownDisplay';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CountdownDisplay />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;